import { SxProps } from '@mui/material';

export const DrawerBenefitContainerSX: SxProps = {
	'& .MuiDrawer-paper': {
		borderRadius: '8px 8px 0 0',
		overflow: 'hidden',
	},
	position: 'relative',
};

export const DrawerBenefitContentSX: SxProps = {
	maxHeight: {
		xs: '63dvh',
		'@media (min-width: 390px)': {
			maxHeight: '68dvh',
		},
	},
	position: 'relative',
	overflow: 'auto',
	transition: 'height 0.3s ease-in-out !important',
	pt: '30px',
};

export const DrawerBenefitHeaderSX: SxProps = {
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	position: 'sticky',
	top: 0,
	zIndex: 1000,
	backgroundColor: 'background.paper',
	px: 2,
};

export const DrawerBenefitHeaderTitleSX: SxProps = {
	fontSize: 'var(--font-size-lg)',
	fontWeight: 800,
	textTransform: 'uppercase',
	color: '#2C2C2C',
	mb: '20px',
};
